import React, { Component } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Button,
  FormText,
  Alert
} from "reactstrap";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {searchMachine} from '../../store/actions/machineActions'
import UpdateMachine from "./UpdateMachine";
import AddMachineMoreInfo from "./AddMachineMoreInfo";
import UpdateMachineMoreInfo from "./UpdateMachineMoreInfo";

class SearchMachine extends Component {
  state = {
    UHANo: '',
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    // console.log(this.state);
    this.props.searchMachine(this.state.UHANo, this.props.profile.unit, this.props.profile.userType);
  };

  render() {
    const { machine } = this.props;
    return (
      <div>
        <Card>
          <CardBody>
            <Form onSubmit={this.handleSubmit}>
              <FormGroup>
                <FormText>UHA No</FormText>
                <Input
                  required
                  type="text"
                  name="UHANo"
                  id="UHANo"
                  placeholder="Ex : 20500"
                  onChange={this.handleChange}
                />
              </FormGroup>
              <ToastContainer />
              <FormGroup>
                <Button color="primary" block>
                  Search
                </Button>
              </FormGroup>
            </Form>
          
          </CardBody>
        </Card>

        {machine ? machine.map(item =>{
          return(
            <div key={item.id} className="mt-3" >
              {this.props.profile.userType === "unit"? 
                ( item.unitInfo === false ? (<AddMachineMoreInfo machine={item} />):(<UpdateMachineMoreInfo machine={item}/>)) : 
                (<UpdateMachine machine={item}/>)
              }
            </div>
          )
        }) : null}
       
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    machine: state.machine.searchedMachine,
    profile: state.firebase.profile,
  };
};


const mapDispatchToProps = (dispatch) => {
  return{
    searchMachine: (UHANo,unit,userType) => dispatch(searchMachine(UHANo,unit,userType))
  }
}

export default compose(
  connect(mapStateToProps,mapDispatchToProps)
)(SearchMachine);

  // firestoreConnect((props) => {
  //   console.log(props.profile);
  //   return [
  //     props.profile.isLoaded
  //       ? {
  //           collection: "machines",
  //           where: ["unit", "==", "7 SLE"],
  //         }
  //       : { collection: "machines" },
  //   ];
  // })